import { defineMessages } from '@/components/formatted_message/FormattedMessage';
import { APP_DICTIONARY } from './root';

export const COMMON_TABLE_MESSAGES_TRANSLATED = defineMessages({
  // Columns
  active: {
    id: 'app.common.table.active',
  },
  buildingVolume: {
    id: 'app.common.table.buildingVolume',
  },
  cn: {
    id: 'app.common.table.cn',
  },
  floorArea: {
    id: 'app.common.table.floorArea',
  },
  editColumns: {
    id: 'app.common.table.editColumns',
  },
  search: {
    id: 'app.common.search',
  },
  columnConfiguratorResetDefault: {
    id: 'app.components.TableColumnConfigurator.resetDefault',
  },

  // Views
  generalView: {
    id: 'app.common.table.view.general',
  },
  ...APP_DICTIONARY,
  status: {
    id: 'app.common.table.status',
  },
  recipients: {
    id: 'app.common.table.recipients',
  },
  reorganizeColumns: {
    id: 'app.common.table.reorganizeColumns',
  },
});
